import * as React from 'react'
import PdfHandler from '@/components/pdfHandler/PdfHandler'
import { View, Text, StyleSheet, Svg, Line } from '@react-pdf/renderer'
import { IFullSchema } from '@/store/apis/schemas'
import { useTranslation } from 'react-i18next'

const styles = StyleSheet.create({
  title: {
    fontSize: 24,
    textAlign: 'center',
    marginBottom: 20,
  },
  scene: {
    marginBottom: 20,
  },
  sceneWrapper: {
    marginBottom: 20,
  },
  scenes: {
    marginTop: 12,
    marginLeft: 25,
    fontSize: 14,
    textAlign: 'justify',
  },
  userWrapper: {
    marginBottom: 20,
  },
  users: {
    marginTop: 12,
    marginLeft: 50,
    fontSize: 12,
    textAlign: 'justify',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
})

interface IPdfHandlerProps {
  schema: IFullSchema
}

const PdfSceneGroups: React.FC<IPdfHandlerProps> = ({ schema }) => {
  const { t } = useTranslation()
  const mappedData = schema.sceneGroups.map((sceneGroup) => {
    const alreadyAddedUsers: number[] = []
    sceneGroup.scenes.map((scene) => {
      const foundScene = schema.scenes.find(
        (schemaScene) => schemaScene.scene.id === scene.id,
      )
      return foundScene.users.map((user) => {
        if (!alreadyAddedUsers.includes(user.id)) {
          alreadyAddedUsers.push(user.id)
        }
      })
    })
    const userData = schema.users.filter((user) =>
      alreadyAddedUsers.includes(user.id),
    )
    const users =
      userData.length < schema.users.length
        ? userData
            .map((user) => `${user.firstName} ${user.lastName}`)
            .join(', ')
        : t('pdf.all').toUpperCase()
    return {
      name: sceneGroup.sceneGroup.name,
      scenes: [...sceneGroup.scenes].map((scene) => scene.name).join(', '),
      users,
    }
  })
  return (
    <PdfHandler
      title={`${t('sceneGroupsPdf.title')} - ${schema.schema.schema.name}`}
    >
      <Text
        style={styles.title}
      >{`${t('sceneGroupsPdf.title')} - ${schema.schema.schema.name}`}</Text>
      {mappedData.map((sceneGroup, index) => (
        <View key={index} style={styles.scene}>
          <Text>{sceneGroup.name}</Text>
          <View style={styles.sceneWrapper}>
            <Text style={styles.scenes}>{sceneGroup.scenes}</Text>
            <View style={styles.userWrapper}>
              <Text style={styles.users}>{sceneGroup.users}</Text>
            </View>
          </View>
          <Svg height="10" width="1000">
            <Line
              x1="0"
              y1="5"
              x2="280"
              y2="5"
              strokeWidth={1}
              stroke="rgb(0,0,0)"
            />
          </Svg>
        </View>
      ))}
      <Text
        style={styles.pageNumber}
        render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
        fixed
      />
    </PdfHandler>
  )
}

export default PdfSceneGroups
